export const CAMERA             = "CAMERA";
export const CATEGORY           = "CATEGORY";
export const CREDITS            = "CREDITS";
export const GAME               = "GAME";
export const SETTINGS           = "SETTINGS";
export const SETTINGS_PLAYER    = "SETTINGS_PLAYER";
export const TITLE              = "TITLE";